import { BCMSCurrency, useBCMSModal } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRow } from "components/shared";
import React, { useEffect } from "react";
import { SVGAsset } from "res";
import ACHTransfersToTable from "../../../../shared/widgets/ACHWidgets/ACHTransfersToTable";
import MobileACHTransfersToTable from "../../../../shared/widgets/ACHWidgets/MobileACHTransfersToTable";
import "./mobile.css";
/**
 * @function OneTimeACHToSection 
 * @param {STRING} creditAmount - Sets the ACH credit amount text. 
 * @return {React.Component}
 * @exported true
 * @description The is the one time ACH To section for OneTimeACHPaymentPage
 */
export default function OneTimeACHToSection(props) {
    const ui = props.ui ?? {};
    const data = props.data ?? {};
    const action = props.action ?? {};
    const { open } = useBCMSModal();
    const participants = data.participants ?? [];
    const achToParticipants = data.achToParticipants ?? [];
    const onParticipantRowChange = action.onParticipantRowChange ?? (() => {});
    const onParticipantModalCancelOnlyClick = action.onParticipantModalCancelOnlyClick ?? (() => {});
    const onParticipantModalCancelClick = action.onParticipantModalCancelClick ?? (() => {});
    const onParticipantsModalAddSelectedParticipantsClick  = action.onParticipantsModalAddSelectedParticipantsClick ?? (() => {});
    const onACHToParticipantChange = action.onACHToParticipantChange ?? (() => {});
    const onACHToParticipantDelete = action.onACHToParticipantDelete ?? (() => {});
    const onSelectAllParticipantsCheckboxChange = action.onSelectAllParticipantsCheckboxChange ?? (() => {});
    const onfilteredParticipantsInSearch = action.onfilteredParticipantsInSearch ?? (() => {});
    const groupSearchValue = data.groupSearchValue ?? "";
    const achParticipantsModalIsOpen = ui.achParticipantsModalIsOpen.isActive ?? false;
    const onAddParticipantsOpenModalClick = action.onAddParticipantsOpenModalClick ?? (() => {});
    const onParticipantGroupInputChange = action.onParticipantGroupInputChange ?? (() => {});
    const participantGroupSearch = data.participantGroupSearch ?? "";
    const onParticipantGroupFilterClick = action.onParticipantGroupFilterClick ?? (() => {});

    const inAchToParicipants =(id)=>{
        return  achToParticipants.participants.filter((toParticipant)=>{
                return toParticipant.participant?  toParticipant.participant.id == id: false;
            }).length !== 0;
        }
        const unUsedParticipants = participants.filter((participant)=>{
            return !inAchToParicipants(participant.id)
        })
      
   
let modalData = { "participants": unUsedParticipants, onParticipantRowChange, groupSearchValue,
        onParticipantModalCancelClick, onParticipantModalCancelOnlyClick, onParticipantsModalAddSelectedParticipantsClick, 
        onSelectAllParticipantsCheckboxChange, onfilteredParticipantsInSearch, onParticipantGroupInputChange, participantGroupSearch,
        onParticipantGroupFilterClick
    };

    let amount = achToParticipants.participants.reduce((acc, item) => {
        const currAmount = item.amount.amount;
        if(currAmount) return acc + parseFloat(currAmount);
        return acc;
    }, 0);
    amount = BCMSCurrency.init(amount);

    // HACK: Pass data to modal through use effect since renders do not propagate to modals.
    useEffect(() => {
        if(achParticipantsModalIsOpen) open("ACHParticipantsModal", modalData);
    }, [ participants ]);

    // On click, we will set "achParticipantsModalIsOpen" to true which will tell us that the modal is open.
    // We will pass data to the modal through the "open" hook.
    const onAddParticipantsClick = evt => {
        onAddParticipantsOpenModalClick();
        open("ACHParticipantsModal", modalData);
    };

    return (
        <div className="one-time-ach-payment-section ach-to-section">
            <h2 className="section-title">ACH To</h2>
            <div className="show-on-desktop">
                <ACHTransfersToTable achToParticipants={ achToParticipants } onACHToParticipantChange={ onACHToParticipantChange } onACHToParticipantDelete={ onACHToParticipantDelete } />
            </div>
            <div className="show-on-mobile">
                <MobileACHTransfersToTable achToParticipants={ achToParticipants } onACHToParticipantChange={ onACHToParticipantChange } onACHToParticipantDelete={ onACHToParticipantDelete } />
            </div>
            <FormContainer className="small-form-width">
                <FormRow>
                    <p className="form-detail-row flex-container align-center">
                        <span className="form-detail form-detail-label">Credit Amount</span>
                        <span className="form-detail form-detail-text"> { amount.format() }</span>
                        <SVGAsset id="QuestionMarkCircleIcon" className="question-mark-circle-icon" />
                    </p>
                </FormRow>
                <FormRow>
                    <a className="clickable" onClick={ onAddParticipantsClick }>
                        <span data-point={ `One_Time_ACH_Add_Participants_Link` }>Add Participants</span>
                    </a>
                </FormRow>
            </FormContainer>
        </div>
    )
}
